/**
 * DSGVO Art. 30 - Verzeichnis von Verarbeitungstätigkeiten
 * Interface definitions for GDPR Processing Activities Record
 */

/**
 * Kategorien personenbezogener Daten
 */
export enum DataCategory {
    BASIC_DATA = 'basic_data',             // Name, Kontaktdaten
    IDENTIFICATION_DATA = 'identification_data', // Ausweisnummer, Kundennummer
    LOCATION_DATA = 'location_data',       // Standortdaten
    COMMUNICATION_DATA = 'communication_data',   // E-Mail, Telefon
    FINANCIAL_DATA = 'financial_data',     // Bankverbindung, Zahlungsdaten
    CONTRACT_DATA = 'contract_data',       // Vertragsdaten
    USAGE_DATA = 'usage_data',             // Nutzungsverhalten, Logs
    TECHNICAL_DATA = 'technical_data',     // IP-Adresse, Browser
    HEALTH_DATA = 'health_data',           // Gesundheitsdaten (Art. 9 DSGVO)
    BIOMETRIC_DATA = 'biometric_data',     // Biometrische Daten (Art. 9 DSGVO)
    GENETIC_DATA = 'genetic_data',         // Genetische Daten (Art. 9 DSGVO)
    SPECIAL_CATEGORIES = 'special_categories',   // Besondere Kategorien (Art. 9 DSGVO)
    PARTNERS = 'partners',                           // Geschäftspartner
    OTHERS = 'others',                             // Sonstige
}


/**
 * Kategorien betroffener Personen
 */

export enum DataSubjectCategory {
    CUSTOMERS = 'customers',                         // Kunden
    EMPLOYEES = 'employees',                         // Mitarbeiter
    APPLICANTS = 'applicants',                       // Bewerber
    SUPPLIERS = 'suppliers',                         // Lieferanten
    INTERESTED_PARTIES = 'interested_parties',       // Interessenten
    USERS = 'users',                                 // Nutzer/Anwender
    NEWSLETTER_SUBSCRIBERS = 'newsletter_subscribers',// Newsletter-Abonnenten
    WEBSITE_VISITORS = 'website_visitors',           // Website-Besucher
    PARTNERS = 'partners',                           // Geschäftspartner
    OTHERS = 'others',                               // Sonstige
}

/**
 * Rechtliche Grundlage der Verarbeitung
 */
export enum LegalBasis {
    CONSENT = 'consent', // Art. 6 Abs. 1 lit. a DSGVO - Einwilligung
    CONTRACT = 'contract', // Art. 6 Abs. 1 lit. b DSGVO - Vertragserfüllung
    LEGAL_OBLIGATION = 'legal_obligation', // Art. 6 Abs. 1 lit. c DSGVO - Rechtliche Verpflichtung
    VITAL_INTERESTS = 'vital_interests', // Art. 6 Abs. 1 lit. d DSGVO - Lebenswichtige Interessen
    PUBLIC_INTEREST = 'public_interest', // Art. 6 Abs. 1 lit. e DSGVO - Öffentliches Interesse
    LEGITIMATE_INTEREST = 'legitimate_interest' // Art. 6 Abs. 1 lit. f DSGVO - Berechtigtes Interesse
}

/**
 * Kategorien von Empfängern
 */
export enum RecipientCategory {
    IT_SERVICE_PROVIDER = 'it_service_provider',           // IT-Dienstleister
    CLOUD_HOSTING = 'cloud_hosting',                       // Cloud-Hosting-Anbieter
    CLOUD_STORAGE = 'cloud_storage',                       // Cloud-Storage-Anbieter
    EMAIL_SERVICE = 'email_service',                       // E-Mail-Service-Provider
    PAYMENT_PROVIDER = 'payment_provider',                 // Zahlungsdienstleister
    MARKETING_TOOLS = 'marketing_tools',                   // Marketing-Tools
    ANALYTICS_PROVIDER = 'analytics_provider',             // Analytics-Anbieter
    AI_SERVICE_PROVIDER = 'ai_service_provider',          // KI-Service-Provider
    SUPPORT_TOOLS = 'support_tools',                       // Support-/Helpdesk-Tools
    ACCOUNTING_SERVICE = 'accounting_service',             // Buchhaltungsservice
    LEGAL_SERVICE = 'legal_service',                       // Rechtsdienstleister
    AUTHORITIES = 'authorities',                           // Behörden
    INSURANCE_PROVIDER = 'insurance_provider',             // Versicherungen
    BANKING_INSTITUTION = 'banking_institution',           // Banken/Finanzinstitute
    TELECOMMUNICATION = 'telecommunication',               // Telekommunikationsanbieter
    LOGISTICS_PROVIDER = 'logistics_provider',             // Logistik-/Versanddienstleister
    RESEARCH_INSTITUTION = 'research_institution',         // Forschungseinrichtungen
    BUSINESS_PARTNER = 'business_partner',                 // Geschäftspartner
    SUBCONTRACTOR = 'subcontractor',                       // Unterauftragnehmer
    GROUP_COMPANIES = 'group_companies',                   // Konzernunternehmen
    OTHER = 'other'                                        // Sonstige
}
export enum isoCountryCodes {
    AT = 'AT',
    CA = 'CA',
    AU = 'AU',
    JP = 'JP',
    US = 'US',
    BE = 'BE',
    BG = 'BG',
    HR = 'HR',
    CY = 'CY',
    CZ = 'CZ',
    DK = 'DK',
    EE = 'EE',
    FI = 'FI',
    FR = 'FR',
    DE = 'DE',
    GR = 'GR',
    HU = 'HU',
    IE = 'IE',
    IT = 'IT',
    LV = 'LV',
    LT = 'LT',
    LU = 'LU',
    MT = 'MT',
    NL = 'NL',
    PL = 'PL',
    PT = 'PT',
    RO = 'RO',
    SK = 'SK',
    SI = 'SI',
    ES = 'ES',
    SE = 'SE',
    GB = 'GB',
    UK = 'UK',
    IS = 'IS',
    LI = 'LI',
    NO = 'NO',
    CH = 'CH',
}

export enum ProcessingPurposes {
    SERVICE_PROVISION = 'service_provision', // Bereitstellung von Dienstleistungen
    MARKETING = 'marketing',                 // Marketing und Werbung
    CUSTOMER_MANAGEMENT = 'customer_management', // Kundenverwaltung
    COMPLIANCE = 'compliance',               // Einhaltung gesetzlicher Vorschriften
    RESEARCH_AND_ANALYSIS = 'research_and_analysis', // Forschung und Analyse
}
export enum TechnicalMeasure {
    BACKUP = 'backup',                       // Regelmäßige Backups
    TRAINING = 'training',                   // Mitarbeiterschulungen
    ENCRYPTION = 'encryption',               // Datenverschlüsselung
    ACCESS_CONTROL = 'access_control',       // Zugriffskontrollen
    SECURITY_TESTING = 'security_testing',   // Sicherheitstests
    DATA_MINIMIZATION = 'data_minimization', // Datenminimierung
    INCIDENT_RESPONSE = 'incident_response', // Vorfallreaktionspläne
    PSEUDONYMIZATION = 'pseudonymization',   // Pseudonymisierung
}
export enum ThirdCountryGuarantees {
    /**
     1. EU-Standardvertragsklauseln (SCC)
    Am häufigsten verwendet
    Von EU-Kommission vorgegebene Vertragsklauseln
    Beispiel: "EU-Standardvertragsklauseln (EU SCCs)"
    2. Verbindliche interne Datenschutzvorschriften (BCR)
    Für Konzerne mit internationalen Niederlassungen
    Beispiel: "Binding Corporate Rules (BCR)"
    3. Verhaltensregeln / Zertifizierungen
    ISO 27001, Privacy Shield (ungültig seit 2020!)
    Beispiel: "ISO 27001 Zertifizierung"
    4. Angemessenheitsbeschluss
    EU hat Drittland als sicher eingestuft
    Beispiel: "Angemessenheitsbeschluss für UK"
    5. Einwilligung des Betroffenen
    Nur für Einzelfälle
    Beispiel: "Ausdrückliche Einwilligung des Nutzers"
    6. Ausnahmen (Art. 49 DSGVO)
    Vertragserfüllung
    Rechtliche Ansprüche
    Beispiel: "Vertragserfüllung gemäß Art. 49 Abs. 1 lit. b DSGVO"
     */
    EU_STANDARD_CONTRACTUAL_CLAUSES = 'eu_standard_contractual_clauses',
    BINDING_CORPORATE_RULES = 'binding_corporate_rules',
    CODES_OF_CONDUCT_CERTIFICATIONS = 'codes_of_conduct_certifications',
    ADEQUACY_DECISION = 'adequacy_decision',
    DATA_SUBJECT_CONSENT = 'data_subject_consent',
    EXCEPTIONS_ART_49 = 'exceptions_art_49',
    OTHERS = 'others',
    NONE = 'none',
}


/**
 * Empfänger/Kategorien von Empfängern
 */
export interface Recipient {
    id?: string;
    name: string; // Name des Empfängers
    category: RecipientCategory; // Kategorie (z.B. "IT-Dienstleister", "Zahlungsdienstleister")
    country?: isoCountryCodes; // Land
    isThirdCountry: boolean; // Übermittlung in Drittland?
    thirdCountryGuarantees?: string; // Garantien bei Drittland (Art. 49 DSGVO)
    purpose: string; // Zweck der Übermittlung
    // createdAt?: Date;
    // updatedAt?: Date;
}

/**
 * Technische und organisatorische Maßnahmen (TOM)
 */
export interface TechnicalOrganizationalMeasures {
    pseudonymization: boolean; // Pseudonymisierung
    encryption: boolean; // Verschlüsselung
    accessControl: boolean; // Zugriffskontrolle
    dataMinimization: boolean; // Datenminimierung
    backup: boolean; // Backup-Strategie
    incidentResponse: boolean; // Notfallplan
    securityTesting: boolean; // Sicherheitstests
    training: boolean; // Mitarbeiterschulungen
}

/**
 * Hauptstruktur: Verarbeitungstätigkeit
 */
export interface ProcessingActivity {
    id?: string;

    // 1. Name und Kontaktdaten des Verantwortlichen
    controllerName: string; // Name des Verantwortlichen
    controllerContact: string; // Kontaktdaten
    jointControllerName?: string; // Gemeinsam Verantwortlicher (falls vorhanden)
    jointControllerContact?: string;
    representativeName?: string; // Vertreter des Verantwortlichen
    representativeContact?: string;
    dpoName?: string; // Datenschutzbeauftragter
    dpoContact?: string;

    // 2. Zwecke der Verarbeitung
    processingPurpose: string; // Hauptzweck der Verarbeitung
    processingDescription: string; // Detaillierte Beschreibung
    legalBasis: LegalBasis; // Rechtsgrundlage
    legitimateInterestDescription?: string; // Bei berechtigtem Interesse: Beschreibung

    // 3. Kategorien betroffener Personen und Daten
    dataSubjectCategories: DataSubjectCategory[]; // Kategorien betroffener Personen
    dataCategories: DataCategory[]; // Kategorien personenbezogener Daten
    isSpecialCategory: boolean; // Besondere Kategorien (Art. 9 DSGVO)?
    isCriminalData: boolean; // Strafrechtliche Daten (Art. 10 DSGVO)?

    // 4. Empfänger
    recipients: Recipient[]; // Empfänger der Daten

    // 6. Löschfristen
    deletionPeriod?: deletionPeriod[]; // Vorgesehene Löschfrist
    deletionCriteria?: DeletionCriteria[]; // Kriterien für Löschung

    // 7. Technische und organisatorische Maßnahmen
    technicalMeasures: TechnicalOrganizationalMeasures;

    // Zusätzliche Metadaten
    isRegularProcessing: boolean; // Regelmäßige Verarbeitung?
    riskAssessment?: RiskLevel; // Risikobewertung
    dataProtectionImpactAssessment?: boolean; // DSFA erforderlich?
    createdAt?: Date;
    updatedAt?: Date;
    createdBy?: string; // User-ID
    status: 'active' | 'inactive' | 'draft'; // Status der Verarbeitung
}
export enum deletionPeriod {
    THREE_YEARS_AFTER_LAST_ACTIVITY = 'three_years_after_last_activity',
    NINETY_DAYS_AFTER_CREATION = 'ninety_days_after_creation',
    SIX_MONTHS_AFTER_REJECTION = 'six_months_after_rejection',
    UPON_ACCOUNT_DELETION = 'upon_account_deletion',
    AFTER_CONTRACT_END = 'after_contract_end',
    UPON_USER_REQUEST = 'upon_user_request',
    TEN_YEARS_SECTION_147_AO = 'ten_years_section_147_ao',
    SIX_YEARS_SECTION_257_HGB = 'six_years_section_257_hgb',
    TEN_YEARS_AFTER_CONTRACT_END_OR_REQUEST = 'ten_years_after_contract_end_or_request',
    UNTIL_MANUAL_DELETION_BY_USER = 'until_manual_deletion_by_user',
}

/**
 * Löschkriterien - Art und Weise der Datenlöschung
 */
export enum DeletionCriteria {
    AUTOMATED_TIME_BASED = 'automated_time_based',           // Automatische zeitbasierte Löschung
    AUTOMATED_EVENT_BASED = 'automated_event_based',         // Automatische ereignisbasierte Löschung
    MANUAL_USER_REQUEST = 'manual_user_request',             // Manuelle Löschung auf Nutzeranfrage
    MANUAL_ADMIN_REVIEW = 'manual_admin_review',             // Manuelle Löschung nach Admin-Prüfung
    LEGAL_RETENTION_PERIOD = 'legal_retention_period',       // Gesetzliche Aufbewahrungspflicht
    CONTRACT_END_TRIGGERED = 'contract_end_triggered',       // Vertragsende als Löschauslöser
    GDPR_RIGHT_TO_ERASURE = 'gdpr_right_to_erasure',        // DSGVO Recht auf Löschung (Art. 17)
    TECHNICAL_OVERWRITE = 'technical_overwrite',             // Technisches Überschreiben
    ARCHIVING_THEN_DELETE = 'archiving_then_delete',         // Archivierung vor Löschung
    ANONYMIZATION_INSTEAD = 'anonymization_instead',         // Anonymisierung statt Löschung
}

/**
 * Risikobewertung für Verarbeitungstätigkeiten
 */
export enum RiskLevel {
    NO_RISK = 'no_risk',                     // Kein Risiko - Routine-Verarbeitungen
    LOW_RISK = 'low_risk',                   // Geringes Risiko - Minimale Auswirkungen
    NORMAL_RISK = 'normal_risk',             // Normales Risiko - Standard-Verarbeitungen
    HIGH_RISK = 'high_risk',                 // Hohes Risiko - Erhebliche Auswirkungen möglich
    VERY_HIGH_RISK = 'very_high_risk',       // Sehr hohes Risiko - DSFA erforderlich (Art. 35)
}
/**
 * Für Auftragsverarbeiter (Art. 30 Abs. 2 DSGVO)
 */
export interface ProcessorActivity {
    id?: string;

    // 1. Name und Kontaktdaten
    processorName: string; // Name des Auftragsverarbeiters
    processorContact: string;
    controllerName: string; // Name des Verantwortlichen (Auftraggeber)
    controllerContact: string;
    representativeName?: string;
    representativeContact?: string;
    dpoName?: string;
    dpoContact?: string;

    // 2. Kategorien von Verarbeitungen
    processingCategories: string[]; // Kategorien der Verarbeitung
    processingDescription: string;

    // 3. Drittlandübermittlung
    hasThirdCountryTransfer: boolean;
    thirdCountries?: string[];
    thirdCountryGuarantees?: string;

    // 4. Technische und organisatorische Maßnahmen
    technicalMeasures: TechnicalOrganizationalMeasures;

    // Zusätzliche Metadaten
    contractDate?: Date; // Datum des Auftragsverarbeitungsvertrags
    contractReference?: string; // Referenz zum Vertrag
    createdAt?: Date;
    updatedAt?: Date;
    status: 'active' | 'inactive' | 'draft';
}

/**
 * Export-Format für Aufsichtsbehörde
 */
export interface ProcessingActivityExport {
    exportDate: Date;
    companyName: string;
    companyAddress: string;
    activities: ProcessingActivity[];
    processorActivities?: ProcessorActivity[];
    metadata: {
        totalActivities: number;
        hasSpecialCategories: boolean;
    };
}
export interface GdprObligationCheckResponse {
    obligated: boolean;
    reason: string;
}